import { store } from "..";

const getServiceProvider = () => {
  return store.getState().serviceProvider?.isElmServiceProvider;
};

// Dashboard URL helper
export const getDashboardUrl = (appId) => {
  const isElmServiceProvider = getServiceProvider();

  if (isElmServiceProvider === "cross_sell_elm") {
    return `/herofin-service/home/v1/${appId}/`;
  } else if (isElmServiceProvider === "cross_sell") {
    return `/herofin-service/home/${appId}/`;
  }
};

// User Device Info URL helper
export const getUserDeviceInfoUrl = () => {
  const isElmServiceProvider = getServiceProvider();

  if (isElmServiceProvider === "cross_sell_elm") {
    return `/cross-sell-offers/v1/user_device_details/`;
  } else if (isElmServiceProvider === "cross_sell") {
    return `/cross-sell/user_device_details/`;
  }
};

// Offer Details URL helper
export const getOfferDetailsUrl = (path, isAccount = false) => {
  const isElmServiceProvider = getServiceProvider();

  if (isAccount) {
    return isElmServiceProvider === "cross_sell_elm"
      ? `/accounts/elm-all-offers/`
      : isElmServiceProvider === "cross_sell"
        ? `/accounts/all-offers/`
        : "";
  }

  return isElmServiceProvider === "cross_sell_elm"
    ? `/cross-sell-offers/v1/${path}/`
    : isElmServiceProvider === "cross_sell"
      ? `/cross-sell/${path}/`
      : ""
};

// Applicant Details URL helper
export const getApplicantDetailsUrl = (path) => {
  const isElmServiceProvider = getServiceProvider();

  if (isElmServiceProvider === "cross_sell_elm") {
    return `/cross-sell-offers/v1/${path}/`;
  } else if (isElmServiceProvider === "cross_sell") {
    return `/cross-sell/${path}/`;
  }
};

// DigiKYC URL helper
export const getDigiKycInitUrl = () => {
  const isElmServiceProvider = getServiceProvider();

  if (isElmServiceProvider === "cross_sell_elm") {
    return "/cross-sell-offers/v1/digikyc_init_data/";
  } else if (isElmServiceProvider === "cross_sell") {
    return "/cross-sell/digikyc_init_data/";
  }
};

// DigiKYC response URL helper
export const getDigiKycRespUrl = () => {
  const isElmServiceProvider = getServiceProvider();

  if (isElmServiceProvider === "cross_sell_elm") {
    return "/cross-sell-offers/v1/process_digikyc_response/";
  } else if (isElmServiceProvider === "cross_sell") {
    return "/cross-sell/process_digikyc_response/";
  }
};

// Verify PAN URL helper
export const getVerifyPanUrl = () => {
  const isElmServiceProvider = getServiceProvider();

  if (isElmServiceProvider === "cross_sell_elm") {
    return "/cross-sell-offers/v1/pre_kyc_details/";
  } else if (isElmServiceProvider === "cross_sell") {
    return "/cross-sell/pre_kyc_details/";
  }
};

// Insurance Details URL helper
export const getInsuranceDetailsUrl = (path) => {
  const isElmServiceProvider = getServiceProvider();

  if (isElmServiceProvider === "cross_sell_elm") {
    return `/cross-sell-offers/v1/${path}/`;
  } else if (isElmServiceProvider === "cross_sell") {
    return `/cross-sell/${path}/`;
  }
};

// Nominee Details URL helper
export const getNomineeDetailsUrl = () => {
  const isElmServiceProvider = getServiceProvider();

  if (isElmServiceProvider === "cross_sell_elm") {
    return `/cross-sell-offers/v1/enter_nominee_details/`;
  } else if (isElmServiceProvider === "cross_sell") {
    return `/cross-sell/enter_nominee_details/`;
  }
};

// Alternate Address Details URL helper
export const getAlternateAddressDetailsUrl = (path) => {
  const isElmServiceProvider = getServiceProvider();

  if (isElmServiceProvider === "cross_sell_elm") {
    return `/cross-sell-offers/v1/${path}/`;
  } else if (isElmServiceProvider === "cross_sell") {
    return `/cross-sell/${path}/`;
  }
};

// Reference Details URL helper
export const getReferenceDetailsUrl = () => {
  const isElmServiceProvider = getServiceProvider();

  if (isElmServiceProvider === "cross_sell_elm") {
    return `/cross-sell-offers/v1/reference_details_api/`;
  } else if (isElmServiceProvider === "cross_sell") {
    return `/cross-sell/reference_details_api/`;
  }
};

// Mandate URL helper
export const getMandateUrl = (path) => {
  const isElmServiceProvider = getServiceProvider();

  if (isElmServiceProvider === "cross_sell_elm") {
    return `/cross-sell-offers/v1/${path}/`;
  } else if (isElmServiceProvider === "cross_sell") {
    return `/cross-sell/${path}/`;
  }
};

// ESign URL helper
export const getESignUrl = (path) => {
  const isElmServiceProvider = getServiceProvider();

  if (isElmServiceProvider === "cross_sell_elm") {
    return `/cross-sell-offers/v1/${path}/`;
  } else if (isElmServiceProvider === "cross_sell") {
    return `/cross-sell/${path}/`;
  }
};

// Congratulations URL helper
export const getCongratulationsUrl = (path) => {
  const isElmServiceProvider = getServiceProvider();

  if (isElmServiceProvider === "cross_sell_elm") {
    return `/cross-sell-offers/v1/${path}/`;
  } else if (isElmServiceProvider === "cross_sell") {
    return `/cross-sell/${path}/`;
  }
};

// Create Caller Code URL helper
export const getCallerCodeUrl = () => {
  const isElmServiceProvider = getServiceProvider();

  if (isElmServiceProvider === "cross_sell_elm") {
    return `/cross-sell-offers/v1/create_caller_code/`;
  } else if (isElmServiceProvider === "cross_sell") {
    return `/cross-sell/create_caller_code/`;
  }
};

// Client Logs URL helper
export const getClientLogsUrl = () => {
  const isElmServiceProvider = getServiceProvider();

  if (isElmServiceProvider === "cross_sell_elm") {
    return `/cross-sell-offers/v1/client_logs/`;
  } else if (isElmServiceProvider === "cross_sell") {
    return `/cross-sell/client_logs/`;
  }
};

// VKYC URL helper
export const getVkycUrl = (path) => {
  const isElmServiceProvider = getServiceProvider();

  if (isElmServiceProvider === "cross_sell_elm") {
    return `/cross-sell-offers/v1/${path}/`;
  } else if (isElmServiceProvider === "cross_sell") {
    return `/cross-sell/${path}/`;
  }
};

// Limit Enhancement URL helper
export const getLimitEnhancementUrl = (path) => {
  const isElmServiceProvider = getServiceProvider();

  if (isElmServiceProvider === "cross_sell_elm") {
    return `/cross-sell-offers/v1/${path}/`;
  } else if (isElmServiceProvider === "cross_sell") {
    return `/cross-sell/${path}/`;
  }
};
